var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnSaintKittsandNevis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_20170)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4336 0.0175781H-2.39453V44.9561H62.4336V0.0175781Z",
    fill: "#FFE900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4688 0.0175781L62.3984 32.4141L11.9492 0L62.4688 0.0175781Z",
    fill: "#35A100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.47363 44.9561L-2.35058 11.2764L48.5381 44.9824L-2.47363 44.9561Z",
    fill: "#C70000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4424 34.8574L62.3984 45L51.3857 44.9824L-2.37695 8.93848L-2.32422 0.123047L8.55663 0.0175781L62.4336 34.8574H62.4424Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5254 13.7637L20.3867 10.0547L17.46 12.4277L14.1201 10.2656L15.6494 13.8955L12.7139 16.2686L16.5986 16.1367L18.1191 19.7666L18.9893 16.0576L22.8652 15.9258L19.5254 13.7637ZM43.7129 29.4961L44.583 25.7783L41.6562 28.1514L38.3164 25.9893L39.8457 29.6191L36.9102 31.9922L40.7861 31.8604L42.3154 35.4902L43.1768 31.7813L47.0527 31.6494L43.7129 29.4961Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_20170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnSaintKittsandNevis);
export default __webpack_public_path__ + "static/media/kn Saint Kitts and Nevis.2658419c4876f680095f7be0d7c955b0.svg";
export { ForwardRef as ReactComponent };